import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import Observable from '../../../decorators/Observable';
import AbstractSessionModel from '../../../models/AbstractSessionModel';
import Action from '../../../decorators/Action';

export enum ScreenType {
  CHOOSE_CORPORATE_CATEGORY = 'ChooseCorporateCategory',
  COMPANY_NOT_INCLUDED = 'CompanyNotIncluded',
  CORPORATE_CATEGORY = 'CorporateCategory',
  ENTER_COMPANY_DOMAIN = 'EnterCompanyDomain',
  ENTER_YOUR_COMPANY_DATA = 'EnterYourCompanyData',
  NOT_FOUND_COMPANY = 'NotFoundCompany',
  SEARCH_FOR_BUSINESS = 'SearchForBusiness',
  SELECT_YOUR_COMPANY = 'SelectYourCompany'
}

class ScreenNavigationModel extends AbstractSessionModel {
  @StoreFieldInSession()
  @Observable()
  public currentScreen: ScreenType = ScreenType.SEARCH_FOR_BUSINESS;
  previousScreen: any;

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setCurrentScreen(screen: ScreenType) {
    this.currentScreen = screen;
  }

  getSessionKey(): string {
    return 'findYourBusinessScreenNavigation';
  }
}

export default new ScreenNavigationModel();
